import { handleActions } from 'redux-actions';
import {
  logout,
  setLogin,
  getDownloadUrl,
  setCustomerAdmins,
  setIsAutoLogin,
  saveGridHeader,
  saveGridContent,
  setIdCustomer,
} from 'redux/actions/authActions';

const defaultState = {
  idApp: 9,
  cusNavId: '',
  authToken: '',
  initials: '',
  isCustomer: false,
  clientId: null,
  name: '',
  surname: '',
  mail: '',
  i18: '',
  idCustomer: null,
  urlDownload: null,
  admins: [],
  isAutoLogin: false,
  encryptedInput: '',
  getGridHeader: null,
  getGridContent: null,
};

export default handleActions(
  {
    [setLogin](state, action) {
      const {
        cusNavId,
        authToken,
        initials,
        isCustomer,
        clientId,
        name,
        surname,
        mail,
        i18,
        entradaUsuario,
        entradaEncriptada,
      } = action.payload;
      return {
        ...state,
        cusNavId,
        authToken,
        initials,
        name,
        surname,
        isCustomer,
        clientId,
        mail,
        i18,
        entradaUsuario,
        idCustomer: cusNavId,
        encryptedInput: entradaEncriptada,
      };
    },
    [getDownloadUrl](state, action) {
      return { ...state, urlDownload: action.payload };
    },
    [setCustomerAdmins](state, action) {
      return { ...state, admins: action.payload };
    },
    [setIsAutoLogin](state, action) {
      return { ...state, isAutoLogin: action.payload };
    },
    [saveGridHeader](state, action) {
      return { ...state, getGridHeader: action.payload };
    },
    [saveGridContent](state, action) {
      return { ...state, getGridContent: action.payload };
    },
    [setIdCustomer](state, action) {
      return { ...state, idCustomer: action.payload };
    },
    [logout](state) {
      return {
        ...state,
        cusNavId: '',
        authToken: '',
        initials: '',
        isCustomer: false,
        clientId: null,
        name: '',
        surname: '',
        i18: '',
        entradaUsuario: '',
        encryptedInput: '',
      };
    },
  },
  defaultState
);
